import { TileLayer } from 'leaflet';

export const basemapOrthoLayer: TileLayer = new TileLayer(
  'https://{s}.wien.gv.at/basemap/bmaporthofoto30cm/normal/google3857/{z}/{y}/{x}.jpeg',
  {
    subdomains: ['mapsneu'],
    attribution:
      '&copy; Datenquelle: <a href="http://basemap.at">basemap.at</a>'
  }
);
